"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const design_system_1 = require("@zapier/design-system");
const theme_1 = require("@zapier/theme");
const lodash_1 = require("lodash");
const CustomMapper_1 = __importDefault(require("..//CustomMapper"));
const FloatingMenu_1 = __importDefault(require("../FloatingMenu"));
const Styles = common_utils_1.labelStyles(__filename, {
    root: ({ isDesktop }) => [
        {
            position: 'relative',
        },
        isDesktop && {
            width: '50%',
        },
    ],
    bodyWrapper: {
        padding: `0px ${theme_1.Spacing.small}px`,
    },
    headerWrapper: {
        alignItems: 'center',
        borderBottom: `1px solid ${design_system_1.Colors.grey300}`,
        display: 'flex',
        justifyContent: 'space-between',
        paddingLeft: '10px',
    },
});
const iconTheme = {
    custom: {
        base: {
            color: design_system_1.Colors.grey700,
        },
        hover: {
            color: design_system_1.Colors.blue500,
        },
        focus: {
            outlineColor: design_system_1.Colors.blue500,
            color: design_system_1.Colors.blue500,
        },
    },
};
const PrettyChoices = ({ choiceGroups, onClose, onClickOutside, onFocus, onInsertTag, }) => {
    if (lodash_1.isEmpty(choiceGroups)) {
        return null;
    }
    return (common_utils_1.isolateComponent(FloatingMenu_1.default, { onClickOutside: onClickOutside, onClose: onClose, onFocus: onFocus },
        common_utils_1.isolateComponent("div", { css: Styles.headerWrapper },
            common_utils_1.isolateComponent(design_system_1.Text, { fontWeight: 700 }, "Insert Data \u2026"),
            common_utils_1.isolateComponent(design_system_1.IconButton, { color: "custom", colorTheme: iconTheme, icon: "formX", label: "Close", onClick: onClose, size: "small", tabIndex: -1, tooltipPosition: "west" })),
        common_utils_1.isolateComponent("div", { css: Styles.bodyWrapper },
            common_utils_1.isolateComponent(CustomMapper_1.default, { choiceGroups: choiceGroups, onSelect: onInsertTag }))));
};
exports.default = PrettyChoices;
